import { notifications } from '@mantine/notifications';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { ApiError } from '@/api/client';

/** Zeigt API-Fehler als Benachrichtigung (übersetzt bekannte Codes). */
export function useApiError() {
  const { t, i18n } = useTranslation();
  return useCallback(
    (error: unknown) => {
      let message = (error as Error)?.message ?? String(error);
      if (error instanceof ApiError && error.code && i18n.exists(`errors.${error.code}`)) {
        message = t(`errors.${error.code}`, error.details as Record<string, unknown>);
      }
      notifications.show({ color: 'red', title: t('common.error'), message });
    },
    [t, i18n],
  );
}
